/*************************************************/
/* HEADER                                        */
/*************************************************/
export function header(body) {
    let headerElement;
    const headerLogo = document.querySelector(".header__main");
    let scrollTimer;

    const setStickyHeader = () => {
        const top = window.pageYOffset || document.documentElement.scrollTop
        if (top > headerElement.offsetHeight / 2) {
            headerLogo.style = "display: none";

        } else {
            headerLogo.style = "display: flex";
        }
    }

    const init = () => {
        headerElement = document.querySelector(".header");

        // Sticky header
        setStickyHeader();
        window.addEventListener('scroll', e => {
            clearTimeout(scrollTimer);
            scrollTimer = setTimeout(function () {
                setStickyHeader();
            }, 10);
        });
    };

    init();

}

